<template>
  <div>
    <p>{{ $t('reports.penibility_informations') }}</p>
    <div class="table-responsive">
      <table :id="tableid">
        <thead>
          <tr><td/></tr>
        </thead>
        <tbody>
          <template v-for="(penib, key) in sortedReport">
            <tr>
              <td>
                <h5 class="font-weight-bold">{{ $t('reports.displays.'+key) }} : {{ penib.ratio }}&percnt; {{ false ? `(${penib.score} / ${penib.max_score})` : '' }}</h5>
              </td>
            </tr>
            <tr>
              <td v-if="showDetails">
                <ul>
                  <li v-for="(requirement, id) in penib" v-if="parseInt(id) == id">
                    {{ requirement.code }} {{ requirement.description }} : {{ requirement.score }}/{{ requirement.max_score }}<br>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'PenibilityDisplay',

  props: {
    penibility: {
      type: Object,
      required: true
    },
    tableid: {
      type: String,
      required: true
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({

  }),

  computed: {
    sortedReport: function () {
      var sortedReport = {}
      for (var k in this.penibility) {
        if (this.penibility.hasOwnProperty(k)) {
          var sorted = {}
          var sortable = []
          for (var penib in this.penibility[k]) {
            if (this.penibility[k].hasOwnProperty(penib)) {
              if (penib == parseInt(penib)) {
                sortable.push(this.penibility[k][penib])
              } else {
                sorted[penib] = this.penibility[k][penib]
              }
            }
          }
          sortable.sort(this.sortCodeCallback(1)).forEach(function (elem, i) {
            sorted[i] = elem
          })
          sortedReport[k] = sorted
        }
      }
      return sortedReport
    }
  },

  mounted () {

  },

  methods: {
    sortCodeCallback (order) {
      var f = function (a, b) {
        var codesA = a.code.split('.').map(x => parseInt(x))
        var codesB = b.code.split('.').map(x => parseInt(x))
        var lenA = codesA.length
        var lenB = codesB.length
        var minLen = lenA < lenB ? lenA : lenB
        for (var i = 0; i < minLen; i++) {
          if (codesA[i] < codesB[i]) { return -order }
          if (codesA[i] > codesB[i]) { return order }
        }
        return order * (lenA - lenB)
      }
      return f
    }
  }
}
</script>
<style>
ul {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/PenibilityDisplay.vue